import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import { Tooltip, calculateContractlength, getContractStartDate, getPersonAgeByContractDate, ssnIsUSABorn } from '../../utils'
import CurrencyFormat from 'react-currency-format';
import InsuranceTaker from '../insurance-taker'
import StartDateOptions from "../start-date-options";
import { getFundTable, fundTableTypes } from '../../api/fund-table/actions'
import KomfortDynamicGuaranteedCapitalForm from "../komfort-dynamik-guaranteed-capital-form";

class VidForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                ageContractEnd: '',
                salary: '',
            }
        }

        this.validateForm = this.validateForm.bind(this)
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.recalculatePayment = this.recalculatePayment.bind(this)

        this.getRetirementAgeSelector = this.getRetirementAgeSelector.bind(this)
        this.getEmployeeContributionSelector = this.getEmployeeContributionSelector.bind(this)

        this.age = React.createRef()
        this.ageContractEnd = React.createRef()
        this.salary = React.createRef()
    }

    componentDidMount() {
        this.props.dispatch(getFundTable());

        if (this.props.initialValues['VIDcontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "VIDcontractstartdate", value: getContractStartDate("VID").format("D.M.YYYY")}, this.props.customerId))
        }

        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        if (isUSABorn) {
            this.props.dispatch(setInfoKey({key: "VIDPortfolio", value: 'perspektive'}, this.props.customerId))
        }


        if(this.props.initialValues.vidConfirm) {
            this.recalculatePayment()
        }
    }

    validateForm() {

        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {

            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 0) {
                        errors.age = 'Að lágmarki 0'
                        valid = false;
                    } else if (parseInt(ageValue) > 80) {
                        errors.age = 'Að hámarki 80'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'ageContractEnd':
                    let ageContractEndValue = this.ageContractEnd.current.value;
                    let contractLength = calculateContractlength(this.props.customerId, ageContractEndValue, this.props.initialValues["VIDcontractstartdate"])

                    let contractIsOneTime = this.props.initialValues['VIDonetime'];

                    // Contracts are generally 5 years mininum, but 2 years for one-time contracts
                    let minContractLength = 5;
                    if (contractIsOneTime) {
                        minContractLength = 2;
                    }
                    
                    // KomfortDynamik contracts are generally 10 years minimum, but 5 years for one-time contracts, and 5 years for VID
                    if (this.props.initialValues["VIDPortfolio"].toLowerCase() === "komfortdynamik") {
                        if (contractIsOneTime) {
                            minContractLength = 5;
                        }
                    }

                    if (contractLength < minContractLength && parseInt(ageContractEndValue) > 0) {
                        errors.ageContractEnd = `Samningur að lágmarki ${minContractLength} ár`
                        valid = false;
                    } else {
                        errors.ageContractEnd = ''
                    }
                    break;
                case 'salary':
                    let value = this.salary.current.state.value
                    if (parseInt(value) > 0) {
                        errors.salary = ''
                    } else {
                        errors.salary = 'Skilyrði að fylla út';
                        valid = false
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }


    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.checked }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeLargeNumberInput(value, name) {
        this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onClickConfirm(event) {
        let validate = this.validateForm()

        if (this.props.isAdult && this.props.initialValues['VIDinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'VIDinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }

        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }

        if (!validate) {
            return false
        }
        
        this.recalculatePayment()
    }

    recalculatePayment()  {
        let beitrag = 0
        let employeeContribution = parseFloat(this.props.infoCollection.VIDemployeecontribution)
        let employerContribution = parseFloat(this.props.infoCollection.VIDemployercontribution)
        let salaryEUR = parseInt(this.props.infoCollection.VIDsalaryisk) / parseInt(this.props.gui.currency)
        beitrag = salaryEUR * ((employeeContribution + employerContribution) / 100)

        this.props.dispatch(setInfoKey({ key: 'VIDamountEUR', value: salaryEUR}, this.props.customerId))
        this.props.dispatch(setInfoKey({ key: 'VIDsalaryEUR', value: beitrag }, this.props.customerId))

        let beitrag2 = 0
        let employeeContribution2 = parseFloat(this.props.infoCollection.VIDTemployeecontribution)
        let employerContribution2 = parseFloat(this.props.infoCollection.VIDTemployercontribution)
        let salaryEUR2 = parseInt(this.props.infoCollection.VIDTsalaryisk) / parseInt(this.props.gui.currency)
        beitrag2 = salaryEUR2 * ((employeeContribution2 + employerContribution2) / 100)

        this.props.dispatch(setInfoKey({ key: 'VIDTamountEUR', value: salaryEUR2}, this.props.customerId))
        this.props.dispatch(setInfoKey({ key: 'VIDTsalaryEUR', value: beitrag2 }, this.props.customerId))
    }

    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    getFunds(fundTable, customerId, initialValues) {
        let allFunds = <select className="custom-select col-12 col-sm-6" id={`vid-former-fund-${customerId}`} name="VIDformerFund" onChange={this.onChangeSelectValue} value={initialValues["VIDformerFund"]} disabled={initialValues.vidConfirm} >
                {fundTable.data && !fundTable.isFetching && fundTable.data.FundTable.FundLine.map((fund) => {
                    return(<option key={fund.FundId} value={fund.FundId}>{fund.Name}</option>)
                })}
            </select>
        return allFunds
    }

    getRetirementAgeSelector(customerId, initialValues){
        let start = 60
        let steps = 68 - start // add one to end age for "up-to" buffer
        let arr = Array.from(new Array(steps), (x, i) => i + start);    // [60,..,67]
        return (
            <select ref={this.ageContractEnd} className="custom-select col-12 col-sm-6" id={`vid-age-by-contract-end-${customerId}`} name="VIDageByContractEnd" onChange={this.onChangeSelectValue} value={initialValues["VIDageByContractEnd"]} disabled={initialValues.vidConfirm} >
                { arr.map((num) => 
                    <option key={num} value={num}>{num}</option>
                )}
            </select>
        )
    }

    getPortfolioSelector(customerId, initialValues){
        let arr = ['KomfortDynamik', 'Perspektive']
        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        const defaultvalue = (isUSABorn ?  'Perspektive' : initialValues["VIDPortfolio"]).toLowerCase();
        return (
            <>   
            <select className="custom-select col-12 col-sm-6" id={`vid-portfolio-${customerId}`} name="VIDPortfolio" onChange={this.onChangeSelectValue} value={defaultvalue} disabled={initialValues.vidConfirm} >
                { arr.map((val) => {
                    let disabled = false
                    if (val === 'KomfortDynamik') {
                        if (!window.KOMFORT_DYNAMIK_ENABLED || isUSABorn) {
                            disabled = true
                        }
                    }
                    return <option key={val} value={val.toLowerCase()} disabled={disabled}>{val}</option>
                })}
            </select>
            {isUSABorn
            ?
                <Tooltip placement="bottom" text={"Samkvæmt upplýsingum úr Þjóðskrá er tryggingartaki fæddur í Bandaríkjunum. Ekki er hægt að velja ávöxtunarleiðina KomfortDynamik. Nánari upplýsingar eru á innri.allianz.is."} />
            :
                <></>
            }
            </>
        )   
    }

    getEmployeeContributionSelector(customerId, initialValues){
        let arr = Array.from(new Array(9), (x, i) => (4 - i/2).toFixed(1));

        return (   
            <select className="custom-select col-12 col-sm-6" id={`vid-employee-contribution-${customerId}`} name="VIDemployeecontribution" onChange={this.onChangeSelectValue} value={initialValues["VIDemployeecontribution"]} disabled={initialValues.vidConfirm} >
                { arr.map((val) => 
                    <option key={val} value={parseFloat(val)}>{val}%</option>
                )}
            </select>
        )   
    }

    getEmployerContributionSelector(customerId, initialValues){
        let arr = Array.from(new Array(41), (x, i) => (20 - i/2).toFixed(1));
        arr.push(7.6)
        arr.push(11.6)
        arr.sort(function (a, b) { return b-a; });

        return (   
            <select className="custom-select col-12 col-sm-6" id={`vid-employer-contribution-${customerId}`} name="VIDemployercontribution" onChange={this.onChangeSelectValue} value={initialValues["VIDemployercontribution"]} disabled={initialValues.vidConfirm} >
                { arr.map((val) => 
                    <option key={val} value={parseFloat(val)}>{val}%</option>
                )}
            </select>
        )   
    }

    render() {
        const { customerId, initialValues, fundTable } = this.props
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["VIDcontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ris-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input id={`ris-contract-age-${customerId}`} name="conract-age" type="number" className="form-control px-2 text-sm-right" value={displayAge} disabled />
                            <input type="hidden" ref={this.age} id={`ris-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={initialValues["age"]} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <strong>{initialValues["VIDcontractstartdate"]}</strong>
                        </div>
                    </div>
                    <div className={`${this.state.errors.ageContractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`vid-age-by-contract-end-${customerId}`} className="col-sm-8 col-form-label">
                            Aldur við lok samnings (ár)
                            {this.state.errors.ageContractEnd.length > 0 ?
                                <span className="error"> ({this.state.errors.ageContractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4 text-right">
                            { this.getRetirementAgeSelector(customerId, initialValues) }
                        </div>
                    </div>
                    <div className="form-row align-items-center">
                        <label htmlFor={`vid-contract-length-${customerId}`} className="col-sm-8 col-form-label">Lengd samnings (ár)</label>
                        <div className="col-sm-4">
                            <input id={`vid-contract-length-${customerId}`} type="number" className="form-control text-sm-right" onChange={this.onChangeTextInput} value={calculateContractlength(customerId, initialValues["VIDageByContractEnd"], this.props.initialValues["VIDcontractstartdate"])} disabled />
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-6">
                            <label htmlFor={`vid-portfolio-${customerId}`} className="col-sm-8 col-form-label">Ávöxtunarleið</label>
                        </div>
                        <div className="col-sm-6 text-right">
                            { this.getPortfolioSelector(customerId, initialValues) }
                        </div>
                    </div>

                    <KomfortDynamicGuaranteedCapitalForm customerId={customerId} initialValues={initialValues} disabled={initialValues.vidConfirm} dispatch={this.props.dispatch} keyPrefix="VID" />

                    <div className={`form-row checkbox-row align-items-center`}>
                        <div className="col-8">
                            <div className="col-form-label"><label className="caption-label" htmlFor={`vid-onetime-${customerId}`}>
                                Eingreiðslusamningur
                            </label></div>
                            <input ref={this.onetime} type="checkbox" id={`vid-onetime-${customerId}`} name="VIDonetime" onChange={this.onChangeCheckbox} checked={initialValues["VIDonetime"]} disabled={initialValues.vidConfirm} />
                            <label htmlFor={`vid-onetime-${customerId}`} className="col-sm-10 col-form-label"></label>
                        </div>
                    </div>

                    { !initialValues["VIDonetime"] &&
                        <>                          
                            <div className="form-row align-items-center">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-employee-contribution-${customerId}`} className="col-form-label">Framlag launþega</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    { this.getEmployeeContributionSelector(customerId, initialValues) }
                                </div>
                            </div>
                            <div className="form-row align-items-center">
                                <div className="col-sm-8">
                                    <label htmlFor={`vid-employer-contribution-${customerId}`} className="col-form-label">Framlag atvinnurekanda</label>
                                </div>
                                <div className="col-sm-4 text-right">
                                    { this.getEmployerContributionSelector(customerId, initialValues) }
                                </div>
                            </div>
                        </>
                    }
                    <div className={`${this.state.errors.salary.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`vid-salary-isk-${customerId}`} className="col-sm-8 col-form-label">
                            { initialValues["VIDonetime"] ?
                                <>Upphæð eingreiðslu</>
                                :
                                <>Laun í ISK</>
                            }  
                            {this.state.errors.salary.length > 0 ?
                                <span className="error"> ({this.state.errors.salary}) </span> : ''
                            }
                        </label>
                        <div className="col-12 col-sm-4 text-right currency-isk">
                            <CurrencyFormat
                                ref={this.salary}
                                id={`vid-salary-isk-${customerId}`}
                                name="VIDsalaryisk"
                                type="text"
                                className="form-control"
                                value={initialValues["VIDsalaryisk"]}
                                disabled={initialValues.vidConfirm}
                                thousandSeparator={"."}
                                decimalSeparator={','}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    this.onChangeLargeNumberInput(value, "VIDsalaryisk")
                                    if (!initialValues["VIDonetime"] && !initialValues["VIDTonetime"]) {
                                        this.onChangeLargeNumberInput(value, "VIDTsalaryisk")
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {/* <div className="form-row align-items-center">
                        <div className="col-sm-8">
                            <label htmlFor={`vid-former-fund-${customerId}`} className="col-form-label">Fyrri sjóður</label>
                        </div>
                        <div className="col-sm-4 text-right">
                            {this.getFunds(fundTable, customerId, initialValues)}
                        </div>
                    </div> */}


                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.vidConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="vidConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="vidConfirm" onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default VidForm